import React from 'react';
import { StyleSheet } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { UserAvatarIcon } from '@/assets/icons/user-avatar';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { ActionButton } from '@/feature/account-details/components/ActionButton';
import { UserAvatar } from '@/feature/account-details/components/UserAvatar';

export const UsernameAndAvatarRow = ({
    username,
    avatarUrl,
}: {
    username?: string | null;
    avatarUrl?: string | null;
}) => {
    const navigation = useNavigation();
    return (
        <Row
            alignItems={'center'}
            style={styles.container}
            paddingBottom={'s16'}
            borderBottomWidth={1}
            justifyContent={'space-between'}
        >
            <Row alignItems={'center'}>
                {avatarUrl ? (
                    <UserAvatar avatarUrl={avatarUrl} avatarContainerStyles={styles.avatarContainer} />
                ) : (
                    <UserAvatarIcon />
                )}
                <Box>
                    <Text variant={'bodySmall'} letterSpacing={-0.08} color={ds.colorToken.text.secondary}>
                        Username
                    </Text>
                    <Text variant={'bodyMedium'}>{username ?? ''}</Text>
                </Box>
            </Row>
            <ActionButton buttonText={'Edit'} onPress={() => navigation.navigate('EditUsernameAndAvatar')} />
        </Row>
    );
};

const styles = StyleSheet.create({
    container: {
        paddingTop: 24,
        borderBottomColor: ds.colorValue.border.strong,
    },
    avatarContainer: {
        marginRight: 12,
    },
});
